import maskString from './maskString';

const CPF_LENGTH = 11;
const CNPJ_LENGTH = 14;
const CNPJ_PATTERN = '##.###.###/####-##';
const NON_DOCUMENT_CHAR = /[^0-9A-Z]/g;
const NON_DIGIT = /\D/g;
const DOCUMENT_CHAR = /^[0-9A-Za-z]$/;

/**
 * Máscara de CNPJ para react-input-mask.
 * `*` aceita [A-Za-z0-9] nas 12 primeiras posições; `9` restringe o DV a dígito.
 */
export const MASK_CNPJ = '**.***.***/****-99';

/**
 * Forma canônica do documento: sem máscara e em maiúsculas.
 * Substitui com segurança os replace(/\D/g,'') aplicados a documento —
 * para CPF o resultado é idêntico, já que CPF só tem dígitos.
 */
export function normalizeDocument(value) {
  if (!value && value !== 0) return '';

  return value
    .toString()
    .toUpperCase()
    .replace(NON_DOCUMENT_CHAR, '');
}

/**
 * CPF na forma que o backend espera, a partir de qualquer entrada do usuário —
 * digitada, colada com máscara ou colada com texto em volta. CPF é
 * estritamente numérico, então letra também cai fora.
 */
export function normalizeCpf(value) {
  if (!value && value !== 0) return '';

  return value
    .toString()
    .replace(NON_DIGIT, '')
    .slice(0, CPF_LENGTH);
}

/**
 * CNPJ na forma canônica e limitado ao comprimento do documento. Preserva
 * letra por causa do CNPJ alfanumérico.
 */
export function normalizeCnpj(value) {
  return normalizeDocument(value).slice(0, CNPJ_LENGTH);
}

/**
 * CNPJ mascarado para exibição. Completa com zero à esquerda os registros
 * que perderam o zero enquanto a coluna era numérica.
 */
export function formatCnpj(value) {
  const normalized = normalizeDocument(value);

  if (!normalized) return '';

  return maskString(normalized.padStart(CNPJ_LENGTH, '0'), CNPJ_PATTERN);
}

/**
 * Handler de onKeyPress para campo de documento sem máscara.
 * Bloqueia pontuação, mantendo letra e dígito.
 */
export function blockNonDocumentKey(event) {
  if (DOCUMENT_CHAR.test(event.key)) return;

  event.preventDefault();
}
